import { inject, observer } from "mobx-react";
import * as React from "react";
import { Redirect, Route, RouteProps } from "react-router-dom";

import AuthStore from "./AuthStore";

interface PrivateRouteProps extends RouteProps {
  authStore?: AuthStore;
}

const PrivateRoute = inject("authStore")(
  observer(
    ({ authStore, component: Component, ...rest }: PrivateRouteProps) => {
      const render = Component
        ? (props: any) => <Component {...props} />
        : () => <></>;

      const renderFallback = (props: any) => (
        <Redirect
          to={`/landing?redirect=${props.location.pathname}${encodeURIComponent(
            props.location.search,
          )}`}
        />
      );

      return (
        <Route
          {...rest}
          render={authStore!.isLoggedIn ? render : renderFallback}
        />
      );
    },
  ),
);

export default PrivateRoute;
